import { analytics } from '@heycatch/sdk';
import type { Account } from '../data';
import { isProductAnalyticsEnabled } from './productAnalytics';

if (isProductAnalyticsEnabled()) {
  analytics.init({
    projectKey: 'hck_pk_jTFCp-wijbruu8IV50prV0c9W3Sb_kYd',
    install: {
      framework: 'react',
      frameworkVersion: '18',
      agent: 'cursor',
    },
  });
}

export function identifyHeyCatch(account: Account): void {
  if (account.id == null) return;
  const name = [account.first_name, account.last_name].filter(Boolean).join(' ');
  analytics.setIdentity(String(account.id), {
    email: account.email,
    ...(name ? { name } : {}),
  });
}

export function resetHeyCatch(): void {
  analytics.resetIdentity();
}

export function trackHeyCatch(eventName: string): void {
  analytics.trackEvent(eventName);
}
